import { render, staticRenderFns } from "./SkupPrijavaCreate.vue?vue&type=template&id=38ef746d&scoped=true&"
import script from "./SkupPrijavaCreate.vue?vue&type=script&lang=js&"
export * from "./SkupPrijavaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ef746d",
  null
  
)

export default component.exports